import * as React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
export const FormTextMultiLine = (props: any) => {
  const { name, label, validate } = props;

  const {
    control,
    register,
    formState: { errors },
    getValues,
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={validate}
      render={({ field, fieldState }) => (
        <TextField
          sx={{ minWidth: "md" }}
          {...field}
          disabled={false}
          multiline
          rows={5}
          type="text"
          label={label}
          variant="outlined"
          error={!!errors[name]}
          helperText={(errors[name]?.message ?? "") as string}
          fullWidth
          margin="dense"
          {...register(name)}
        />
      )}
    />
  );
};
